import {
    GetPowerBIReportService,
    TypeModulosBI,
} from "../../../Services/Geral/RelatoriosBI/RelatoriosBIServices";
import { Controller } from "../../Controller";

export async function GetPowerBIReportController(dsModuloBi: TypeModulosBI) {
    return Controller(GetPowerBIReportService(dsModuloBi));
}
